import { ServiceURIEnum } from "./enums/ServiceURI.enum";

const baseURL = process.env.REACT_APP_API_URL;

export const ServiceURI = {
  [ServiceURIEnum.AGENTS]: {
    FATCH_AGENTS: `${baseURL}/v1/agents`,
  },
  [ServiceURIEnum.TEAMS]: {
    FATCH_TEAMS: `${baseURL}/v1/teams`,
  },
  [ServiceURIEnum.TOOLS]: {
    FATCH_TOOLS: `${baseURL}/v1/tools`,
  },
  [ServiceURIEnum.KNOWLEDGE_BASE]: {
    FATCH_KNOWLEDGE_BASE: `${baseURL}/v1/knowledge-base`,
  },
  [ServiceURIEnum.GUARDRAILS]: {
    FATCH_GUARDRAILS: `${baseURL}/v1/guardrails`,
  },
};
